module.exports = __webpack_public_path__ + "img/carrousel-video-11.11f66b60.png";